import { BaseNav, RouteAuthenticationRequirement, useAuth } from '@invara-dev/react-base';
import { BaseNavItem } from '@invara-dev/react-base/dist/BaseComponents/Nav/types';
import { useNavigate } from 'react-router-dom';
import { useCallback } from 'react';
import { Bleed, Box, Stack, type StackProps } from '@chakra-ui/react';
import { SidebarLink } from './sidebar-link';
import { MopspotUser } from '../../globalModels/user/mopspotUser';
import NavItem = BaseNav.NavItem;

interface SidebarNavProps extends StackProps {
  items: BaseNavItem[];
}

export const SidebarNavItems = (props: SidebarNavProps) => {
  const auth = useAuth<MopspotUser>();
  const shouldRenderItem = (item: BaseNavItem): boolean => {
    if (item.text === undefined) {
      return false;
    }
    if (item.authenticationRequirement == RouteAuthenticationRequirement.Authenticated && !auth.isAuthenticated) {
      return false;
    }
    if (item.authenticationRequirement == RouteAuthenticationRequirement.Unauthenticated && auth.isAuthenticated) {
      return false;
    }
    if (!item.allowedRoles) {
      return true;
    }
    if (item.allowedRoles.length == 0 && auth.isAuthenticated) {
      return true;
    }
    if (item.allowedRoles && !auth.isAuthenticated) {
      return false;
    }

    const toReturn = item.allowedRoles.some((allowedRole) => auth.user && auth.user.Roles.includes(allowedRole));
    return toReturn;
  };
  const links = props.items
    .map((navItem) => {
      if (!navItem.subItems) {
        return shouldRenderItem(navItem) ? navItem : undefined;
      }

      const subItems = navItem.subItems.filter((subItem) => shouldRenderItem(subItem));

      if (subItems.length === 0) {
        return undefined;
      }

      return { ...navItem, subItems } as BaseNavItem;
    })
    .filter((navItem): navItem is BaseNavItem => navItem !== undefined);

  const nav = useNavigate();

  const onNavClick = useCallback(
    (navItem: NavItem) => {
      if (navItem.onClick) {
        navItem.onClick();
      }
      if (navItem.path) {
        nav(navItem.path);
      }
    },
    [nav]
  );

  return (
    <Stack gap='2' width={'224px'}>
      {links.map((link, index) => (
        <Bleed key={index} inline='4'>
          <SidebarLink
            disabled={!!link.subItems}
            icon={link.icon}
            onClick={() => onNavClick(link)}
            aria-current={link.path && window.location.pathname.indexOf(link.path) >= 0 ? 'page' : undefined}>
            {link.text}
          </SidebarLink>
          {link.subItems &&
            link.subItems.map((link, subLinkIndex) => (
              <Box key={subLinkIndex} ml='4'>
                <SidebarLink
                  icon={link.icon}
                  onClick={() => onNavClick(link)}
                  aria-current={link.path && window.location.pathname.indexOf(link.path) >= 0 ? 'page' : undefined}>
                  {link.text}
                </SidebarLink>
              </Box>
            ))}
        </Bleed>
      ))}
    </Stack>
  );
};
